import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { EndAutomaticallyDiv, OptionsContainer, OptionsWrap, OptionsWrap2 } from './sessions.styled'
import TwoOptionButton from 'components/utils/TwoOptionButton' 
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select  from '@mui/material/Select';  
import SpinnerSmall from 'components/SpinnerSmall'
import toast from 'react-hot-toast'
import { useDispatch, useSelector } from 'react-redux' 
import { useDelayedAction } from 'hooks/useDelayedAction';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { pBtn } from 'components/main.styled';
import { useTranslation } from 'react-i18next';

export default function SessionSettings(props) {
    const { t } = useTranslation('qna')
  
    const { isLoading, trigger } = useDelayedAction(1000); // default 1s
 

    const [showSettings, setShowSettings] = useState(false); 

    const handleClick = () => {
        trigger(() => setShowSettings(true), 1500); // override to 1.5s if desired
    };

    const handleShowSettings = () => {
        if(showSettings){
            setShowSettings(false)
        }else{
            handleClick()
        }
    }

    const { profileChurch } = useSelector((state) => state.profileChurch)
    const { createQASessionStatus } = useSelector((state) => state.qASession)
    const [ questionVisibility, setQuestionVisibility ] = useState("public")
    const [ requireApproval, setRequireApproval ] = useState(true)
    const [ allowAnonymous, setAllowAnonymous ] = useState(true) 
    const [ limitQuestions, setLimitQuestions ] = useState(false)
    const [ maxQuestions, setMaxQuestions ] = useState(-1) 
 
    const handleSetLimit = (event) => {
        setMaxQuestions(event.target.value)
    }
 

    useEffect(() => {

        // set settings
        setRequireApproval(props.sessionData.requireApproval)
        setQuestionVisibility(props.sessionData.questionVisibility)
        setAllowAnonymous(props.sessionData.allowAnonymous)
        if(props.sessionData.maxQuestions && props.sessionData.maxQuestions > 0){
           setMaxQuestions(props.sessionData.maxQuestions) 
        }
        

    }, [])

    return (
        <SessionDataContainer height={isLoading || showSettings} >
            <SessionDataTitle>
                <span>{t('create.settings')}</span>
                <DropBtn
                    onClick={ handleShowSettings }>
                    {
                        showSettings || isLoading ? (
                            <IoIosArrowUp size={22} />
                        )
                        :
                        (
                            <IoIosArrowDown size={22} />
                        )
                    }
                </DropBtn>
            </SessionDataTitle>
            <SessionDataWrap >  
                {
                     isLoading ?
                    (
                        <div style={{marginTop: "20px"}}>
                           <SpinnerSmall border='#898989' /> 
                        </div>
                        
                    )
                    : showSettings &&
                    (
                        <OptionsContainer>  
                <OptionsWrap>
                    <TwoOptionButton
                        disabled={true}
                        responseTypeLabelWidth={"200px"}
                        componentLabel={"Require Question Approval"}
                        label1={"Yes"}
                        label2={"No"}
                        value1={true}
                        value2={false}
                        valueToCheckIfSelected={requireApproval}
                        callback1={() => setRequireApproval(true)}
                        callback2={() => setRequireApproval(false)} 
                        />                 
                </OptionsWrap>  
                <OptionsWrap>
                    <TwoOptionButton
                        disabled={true}
                        responseTypeLabelWidth={"200px"}
                        componentLabel={"Questions visibility"}
                        label1={"Private"}
                        label2={"Public"}
                        value1={"private"}
                        value2={"public"}
                        valueToCheckIfSelected={questionVisibility}
                        callback1={() => setQuestionVisibility("private")}
                        callback2={() => setQuestionVisibility("public")} 
                        />               
    
                </OptionsWrap>              
                <OptionsWrap>
                    <TwoOptionButton
                        disabled={true}
                        responseTypeLabelWidth={"200px"}
                        componentLabel={"Allow Anonymous Questions"}
                        label1={"Yes"}
                        label2={"No"}
                        value1={true}
                        value2={false}
                        valueToCheckIfSelected={allowAnonymous}
                        callback1={() => setAllowAnonymous(true)}
                        callback2={() => setAllowAnonymous(false)} 
                        />               
    
                </OptionsWrap>  
 
                <OptionsWrap2>
                    <OptionsWrap>
                        <TwoOptionButton
                            disabled={true}
                            responseTypeLabelWidth={"200px"}
                            componentLabel={`Limit Questions Per User ${maxQuestions > 0 ? `(${maxQuestions})`:""}`}
                            label1={"Yes"}
                            label2={"No"}
                            value1={true}
                            value2={false}
                            valueToCheckIfSelected={maxQuestions > 0}
                            callback1={() => setLimitQuestions(true)}
                            callback2={() => setLimitQuestions(false)} 
                            />               
   
                    </OptionsWrap>    
                    {
                        limitQuestions && (
                            <EndAutomaticallyDiv>
                                <FormControl sx={{  m: 1, minWidth: 100, maxWidth: 220 }}>
                                    <InputLabel id="demo-simple-select-label">Max</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        sx={{ height: 45 }}
                                        value={maxQuestions}
                                        label="Max"
                                        onChange={handleSetLimit}
                                        >   
                                        <MenuItem value={1}>1</MenuItem>
                                        <MenuItem value={2}>2</MenuItem>
                                        <MenuItem value={3}>3</MenuItem>
                                        <MenuItem value={4}>4</MenuItem>
                                        <MenuItem value={5}>5</MenuItem>
                                        <MenuItem value={6}>6</MenuItem>
                                        <MenuItem value={7}>7</MenuItem>
                                        <MenuItem value={8}>8</MenuItem>
                                        <MenuItem value={9}>9</MenuItem>
                                        <MenuItem value={10}>10</MenuItem>  
                                    </Select>
                                </FormControl> 
                            </EndAutomaticallyDiv>
                        )
                    }                
                    </OptionsWrap2>

                    </OptionsContainer>
                    )
                }

            </SessionDataWrap> 

        </SessionDataContainer>
    )
}

const DropBtn = styled.div`
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    transition: all .3s;
    cursor: pointer;
    background-color: #f2f6f8;
    color: #626b70;

    &:hover{
        background-color: #eef1f3;
    }

`

const EndSessionButton = styled(pBtn)`
    
    color: #9d9d9d; 
    border: 2px solid #ccc;   
    background-color: ${props => props.disabled ? `#ccc` : 'none'};
    pointer-events: ${props => props.disabled ? 'none' : 'all'};

    @media (max-width: 768px) {
        align-self: center;
        justify-self: center;
    }
    &:hover{ 
        color: white;
        border: 2px solid red;
        background-color: red;
    }


`

const SessionDataContainer = styled.div`
    position: relative;
    padding: 18px;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    width: 100%;
    
    height: ${props => props.height ? "360px":"50px"};
    margin-top: 20px;
    background-color: white ;
    border-radius: 8px;
    border: 1px solid #edf0f2;
    box-shadow: 0 4px 16px rgba(61, 70, 78, 0.10);
    transition: all 0.3s;
`

const SessionDataTitle = styled.div`
    font-size: 15px;
    width: 100%;
    color: var(--lightThemeFontColor); 
    background-color: white;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 5px; 
    font-weight: 700;
`

const SessionDataWrap = styled.div` 
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 360px;
    overflow-y: scroll;
    transition: all 0.3s;

    @media (max-width: 768px) {
        margin-top: 10px;
    } 
`
